<template>
    <div v-if="modal.backdrop">
        <div
            class="modal fade"
            :class="modal.isOpen ? 'show' : ''"
            tabindex="-1"
            style="display: block"
            role="dialog"
            aria-hidden="true"
            @click="modal.dismiss ? $event.target.classList.contains('modal') ? isModal() : true : true"
        >
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filter</h5>
                        <button type="button" class="close" v-on:click="isModal" v-html="ic('close')"/>
                    </div>

                    <div class="modal-body pt-3">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="Perusahaan" class="form-label">Principal</label>
                                <selectize
                                    id="Principal"
                                    @input="_getBrand"
                                    v-model="filters.ids_principal"
                                    :settings="form.selectizeConfig"
                                    data-placeholder="Pilih Principal" required>
                                    <option  
                                        v-for="(principal, index) in datas.principals"
                                        :value="principal.id"
                                        :key="index"> {{principal.nama_principal}}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="Perusahaan" class="form-label">Brand</label>
                                <selectize
                                    id="Brand"
                                    v-model="filters.ids_brand"
                                    :settings="form.selectizeConfig"
                                    data-placeholder="Pilih Brand" required>
                                    <option  
                                        v-for="(brand, index) in datas.brands"
                                        :value="brand.id"
                                        :key="index"> {{brand.nama_brand}}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="Supervisor" class="form-label">Nama Supervisor</label>
                                <selectize
                                    id="Nama_supervisor"
                                    @input="_getTim"
                                    v-model="filters.ids_supervisor"
                                    :settings="form.selectizeConfig"
                                    data-placeholder="Pilih Nama Supervisor" required>
                                    <option  
                                        :value="supervisor.id"
                                        v-for="(supervisor, index) in datas.supervisors"
                                        :key="index"> {{supervisor.nama_sales_supervisor}}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="Tim" class="form-label">Tim</label>
                                <selectize
                                    id="Tim"
                                    v-model="filters.ids_tim"
                                    :settings="form.selectizeConfig"
                                    data-placeholder="Pilih Tim" required>
                                    <option  
                                        :value="tim.id"
                                        v-for="(tim, index) in datas.tims"
                                        :key="index"> {{tim.nama_tim}}
                                    </option>
                                </selectize>
                            </div>

                            <div class="form-group col-md-6">
                                <label for="start_week" class="form-label">Minggul Awal</label>
                                <selectize
                                    id="start_week"
                                    v-model="filters.start_week"
                                    data-placeholder="Pilih Minggu Awal" required>
                                    <option  
                                        :value="week"
                                        v-for="(week, index) in form.totalWeek"
                                        :key="index"> Minggu {{week}}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="end_week" class="form-label">Minggu Akhir</label>
                                <selectize
                                    id="end_week"
                                    v-model="filters.end_week"
                                    data-placeholder="Pilih Minggu Akhir" required>
                                    <option  
                                        :value="week"
                                        v-for="(week, index) in form.totalWeek"
                                        :key="index"> Minggu {{week}}
                                    </option>
                                </selectize>
                            </div>

                            <div class="form-group col-md-6">
                                <label for="start_year" class="form-label">Tahun Awal</label>
                                <selectize
                                    id="tahun_awal"
                                    v-model="filters.start_year"
                                    data-placeholder="Pilih Tahun Akhir"
                                    required>
                                    <option :value="i" v-for="i in form.years" :key="i">{{i}}</option>
                                </selectize>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="tahun_akhir" class="form-label">Tahun Akhir</label>
                                <selectize
                                    id="tahun_akhir"
                                    v-model="filters.end_year"
                                    data-placeholder="Pilih Tahun Akhir"
                                    required>
                                    <option :value="i" v-for="i in form.years" :key="i">{{i}}</option>
                                </selectize>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" @click="isModal" v-html="'Tutup'"></button>
                        <button type="button" class="btn btn-primary" v-html="'OK'" @click="_getReport"></button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
import helper from "@/assets/js/helper.js"
export default ({
    name: "ModalOutletActive",
    mixins: [helper],
    data(){
        return {
            datas: {    
                tims: [],
                brands: [],
                principals: [],
                supervisors: [],
            },
            form: {
                loadingDatas: false,
                totalWeek:52,
                years:[],
                selectizeConfig: {
                    maxItems: 99,
                    plugins: ["remove_button"]
                },
            }
        }
    },
    computed: {
        ...mapState("trakcing_outlet_active",['modal','filters']),
    },
    methods: {
        ...mapActions('trakcing_outlet_active', ['isModal','getTrackingOutletActive']),
        ...mapActions('principal', ['getListPrincipal']),
        ...mapActions('salesman', ['getListSalesmanSpv']),
        ...mapActions('brand', ['getListBrand']),
        ...mapActions('tim', ['getTimBySpv']),


        async _getReport(){
            this.getTrackingOutletActive()
            this.isModal()
        },
        async _getPrincipal(){
            try {
                this.datas.principals = await this.getListPrincipal({})
            } catch (error) {
                this.datas.principals = []
                console.log(error)
            }
        },
        async _getBrand(){
            try {
                this.datas.brands = await this.getListBrand({filter: false, perPage: 'all',id_principal:this.filters.ids_principal})
            } catch (error) {
                this.datas.brands = []
                console.log(error)
            }
        },
        async _getSupervisor(){
            try {
                this.datas.supervisors = await this.getListSalesmanSpv({})
            } catch (error) {
                this.datas.supervisors = []
                console.log(error)
            }
        },
        async _getTim(){
            try {
                this.datas.tims = await this.getTimBySpv({ids_supervisor:this.filters.ids_supervisor})
            } catch (error) {
                this.datas.tims = []
                console.log(error)
            }
        },
        _getYears() {
            const startYear = 2016;
            const currentYear = new Date().getFullYear();
            this.form.years = Array.from({ length: currentYear - (startYear - 1) }, (_, index) => startYear + index);
        },

    },
    mounted(){
        if(this.datas.principals.length == 0) this._getPrincipal()
        if(this.datas.supervisors.length == 0) this._getSupervisor()
        this.getTrackingOutletActive()
        this._getYears()
    }
})
</script>

